// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2CpdL","footer":"Form_footer__2epT9"};